import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./customer_auth_provider.js";
//#region src/customer_auth_provider_helper.ts
var customer_auth_provider_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(customerAuthProvider) {
	switch (customerAuthProvider) {
		case "bite": return "No Third Party Auth";
		case "paytronix": return "Paytronix";
	}
}
//#endregion
export { customer_auth_provider_helper_exports, name };

//# sourceMappingURL=customer_auth_provider_helper.js.map